/* eslint-disable quote-props */
import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

const MAPPINGS = {
  lodef: {
    'American Express': '/assets/card-logos/amex.svg',
    'Diners Club': '/assets/card-logos/diners.svg',
    'Discover': '/assets/card-logos/discover.svg',
    'JCB': '/assets/card-logos/jcb.svg',
    'MasterCard': '/assets/card-logos/mastercard.svg',
    'Visa': '/assets/card-logos/visa.svg',
    'default': '/assets/card-logos/default.svg'
  },

  hidef: {
    'American Express': '/assets/card-logos/amex-hidef.png',
    'Diners Club': '/assets/card-logos/diners-hidef.png',
    'Discover': '/assets/card-logos/discover-hidef.png',
    'JCB': '/assets/card-logos/jcb-hidef.png',
    'MasterCard': '/assets/card-logos/mastercard-hidef.png',
    'Visa': '/assets/card-logos/visa-hidef.png',
    'default': '/assets/card-logos/default.svg'
  }
};

@Pipe({
  name: 'sondermindCardBrandLogoPath',
  pure: true,
  standalone: false
})
export class CardBrandLogoPathPipe implements PipeTransform {
  constructor() {}

  transform(brandName: string, hidef = false): SafeHtml {
    const logos = MAPPINGS[hidef ? 'hidef' : 'lodef'];
    const path = logos[brandName];

    return path || logos.default;
  }
}
